<div [style.--scrollbarWidth]="getScrollbarWidth()">
  <app-nav-header-panel
    [loggedIn]="loggedIn"
    [allowAuthLogout]="allowLogout"
    [displayName]="displayName"
    [authUserName]="authUserName"
    [user]="userDetails$ | async"
    [isMimicMode]="isMimicMode"
    (loginClicked)="login()"
    (logoutClicked)="logout()"
    (authLogout)="authLogout()"
    (resetMimicUser)="resetMimicUser()"
    [ngClass]="{mimic: isMimicMode}"
  ></app-nav-header-panel>

  <main>
    <router-outlet *ngIf="loggedIn"></router-outlet>
  </main>
  <footer>
    <div>Copyright © {{ year }} InComm. All Rights Reserved</div>
    <div>
      <a
        href="https://www.incomm.com/wp-content/uploads/2022/06/InCommInterimAccessibilityStatementFinalApproved8.3.211.pdf"
        target="_blank"
        class="ada-link"
        title="Americans with Disability Act"
        aria-label="Americans with Disability Act accessibility statement"
        rel="noopener"
      >
        <span>ADA</span>
        accessibility statement
      </a>
    </div>
  </footer>

  <div class="loading" [ngClass]="{hide: !isLoader, show: isLoader}">
    <span class="spinner-container">
      <span class="spinner spinner-bounce-middle"></span>
    </span>
  </div>
</div>
<div id="pdf-viewer" class="pdf-viewer-hidden pdf-viewer-backdrop">
  <app-pdf-viewer data-test-id="appr_mgr_pdf_viewer"></app-pdf-viewer>
</div>
